import React from "react";
import { useAppSelector } from "../../../redux/store";
import ServiceDescriptions from "./ServiceDescriptions";
import TransferDetails from "./TransferDetails";
import { useTranslation } from "react-i18next";

const TransferList = () => {
  const booking = useAppSelector((state) => state.booking);
  const transfers = booking.transfers;
  const hasDescriptions = transfers.serviceDescriptions.length > 0;
  const hasPickupInfo = transfers.accomodationCode?.length > 0;
  const { t } = useTranslation();

  return (
    <>
      {hasDescriptions && <ServiceDescriptions />}

      {hasPickupInfo && <TransferDetails />}

      {!hasDescriptions && !hasPickupInfo && (
        <p className="ms-4">{t("bookingDetails.transfers.noTransfers")}</p>
      )}
    </>
  );
};

export default TransferList;
